import React from 'react';
import { injectIntl } from 'react-intl';

import ListFilterAsyncMultiple from 'components/layout/list/ListFilterAsyncMultiple';

class ListFilterProvisionAssignee extends React.Component {
  listItemFormatter = client => `${client.profile.first_name} ${client.profile.last_name}`;

  listItemId = client => {
    return client.username;
  };

  render() {
    const {
      intl: { messages },
    } = this.props;

    return (
      <ListFilterAsyncMultiple
        title={messages.provision_service_documents_provisionAssignee}
        listName="assignees"
        listUrl="/api/clients.json"
        listUrlData={{
          filters: { type: 'employee' },
          matchEmployee: true,
        }}
        listItemFormatter={this.listItemFormatter}
        listItemId={this.listItemId}
        paramName="provisionAssignee"
      />
    );
  }
}
ListFilterProvisionAssignee.defaultProps = {};

export default injectIntl(ListFilterProvisionAssignee);
